import { render, staticRenderFns } from "./club-summary.vue?vue&type=template&id=a251d920&"
import script from "./club-summary.vue?vue&type=script&lang=js&"
export * from "./club-summary.vue?vue&type=script&lang=js&"
import style0 from "./club-summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a251d920')) {
      api.createRecord('a251d920', component.options)
    } else {
      api.reload('a251d920', component.options)
    }
    module.hot.accept("./club-summary.vue?vue&type=template&id=a251d920&", function () {
      api.rerender('a251d920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-summary.vue"
export default component.exports